import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const Header = _ref => {
  let {
    className,
    style,
    children,
    left,
    right
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px',
      width: '100%',
      height: '48px',
      borderBottom: `1px solid ${theme.colors.charcoal200}`
    }, style]
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      flex: 1
    }]
  }, left), children, /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: [{
      display: 'flex',
      alignItems: 'center'
    }]
  }, right));
};
Header.displayName = 'Header';
Header.propTypes = {
  /** Button's content */
  children: PropTypes.node,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Header left side render function */
  left: PropTypes.element,
  /** Header right side render function */
  right: PropTypes.element
};
export default Header;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div")`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "Header___StyledDiv3",
  componentId: "sc-194fy9t-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=Header.js.map